
import { deleteShoninsha, getShoninshaList } from "@/api/account.api";
import { ComfirmMsg, InfoMsg } from "@/constants/message.constant";
import { QueryShoninsha } from "@/interfaces/account.interface";
import { dateFormat } from "@/utils/date";
import { defineComponent, h, reactive, ref } from "vue";
import { ElMessageBox, ElMessage } from "element-plus";
import { DialogGenre } from "@/interfaces/common.interface";
import { tableConfig } from "./tableConfig";
import useDialog from "@/hooks/useDialog";
import useTable from "@/hooks/useTable";
import Dialog from "./Dialog.vue";
import { useUserStore } from "@/store";
import { useRouter } from "vue-router";

// テーブルの各行表示内容
interface IShoninshaInfo {
  id: number;
  accountId: string;
  tantoCd: string;
  tantoNm: string;
  kengen: string;
  createdDate: string;
  updatedDate: string;
}

export default defineComponent({
  name: "shoninsha",
  components: {
    Dialog,
  },
  setup() {
    const userStore = useUserStore();
    const router = useRouter();

    const table = reactive({
      queryForm: {
        name: "",
        page: 1,
        limit: 20,
      } as QueryShoninsha,
      list: [] as IShoninshaInfo[],
      total: 0,
      loading: true,
    });

    //検索メイン処理
    const getList = async () => {
      table.loading = true;
      table.list = [];
      const { data } = await getShoninshaList(table.queryForm);
      const { listData, total } = data.result;
      table.total = total;
      for (let i = 0; i < listData.length; i++) {
        table.list.push({
          id: listData[i].id,
          accountId: listData[i].account.akaunto_id,
          tantoCd: listData[i].tanto_cd,
          tantoNm: listData[i].tanto_nm,
          kengen: listData[i].account.kengen.kengen_kubun,
          createdDate: dateFormat(listData[i].account.toroku_date),
          updatedDate: dateFormat(listData[i].account.koshin_date),
        });
      }
      table.loading = false;
    };

    const tableRef = ref();
    const { handleSizeChange, handleSearch, handleClear } = useTable(
      table,
      getList,
      tableRef
    );

    //削除イベント
    const handleDelete = (row: IShoninshaInfo) => {
      ElMessageBox({
        title: "確認",
        message: h("p", null, [
          h("p", { style: "color: #b87d11" }, "アカウントID：" + row.accountId),
          h("p", { style: "color: #b87d11" }, "担当者名：" + row.tantoNm),
          h("span", null, ComfirmMsg.CFM_DELETE),
        ]),
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "はい",
        cancelButtonText: "いいえ",
      })
        .then(async () => {
          //削除処理
          await deleteShoninsha(row.accountId);
          ElMessage({
            type: "success",
            message: InfoMsg.INFO_SYONINSHA_DELETED,
          });
          if (row.accountId === userStore.getAccountId) {
            userStore.logout();
            router.push("/login");
          } else {
            handleSearch(table.queryForm.page);
          }
        })
        .catch((cancel) => {
          console.log(cancel);
        });
    };

    //ダイアログ利用
    const { dialogTitle, dialogOperation, openDialog } = useDialog("承認者");

    //初期表示時、一回検索
    getList();

    return {
      table,
      tableConfig,
      getList,
      handleClear,
      handleSearch,
      handleDelete,
      DialogGenre,
      dialogTitle,
      dialogOperation,
      openDialog,
      handleSizeChange,
      tableRef,
    };
  },
});
